import React from 'react'
import {
  AuthorBox,
  authorBoxStyle,
  AuthorText,
  BlueBox,
  LabelText,
} from './style/QuestionAnswerBox.css'
import QuestionAnswerText from './QuestionAnswerText'

export default function QuestionAnswerBody({
  questionText,
  questionAuthor,
  answerText,
  answerAuthor,
}) {
  return (
    <>
      <BlueBox>
        <LabelText>
          Q:
        </LabelText>
        <QuestionAnswerText
          text={questionText}
          type="question"
        />
      </BlueBox>
      <AuthorBox>
        <AuthorText>{ questionAuthor }</AuthorText>
      </AuthorBox>
      <BlueBox>
        <LabelText>
          A:
        </LabelText>
        <QuestionAnswerText
          text={answerText}
          type="answer"
        />
      </BlueBox>
      <AuthorBox style={authorBoxStyle}>
        <AuthorText>{ answerAuthor }</AuthorText>
      </AuthorBox>
    </>
  )
}
